export const blockIconsMapsVolunteerActivism = (
	<span className='material-symbols-outlined'>volunteer_activism</span>
);
